import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function () {
  gsap.registerPlugin(ScrollTrigger, CustomEase);

  const gridWrapper = document.querySelector("#fade-in-grid-wrapper");
  const gridItems = document.querySelectorAll('.fade-in-grid-items');
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(!gridWrapper || isReduceMotion) return;

  gsap.fromTo(
    gridItems,
    { opacity: 0, y: 30 },
    {
      opacity: 1,
      y: 0,
      ease: "power2.out",
      duration: 1,
      stagger: { each: 0.3, from: "start" },
      scrollTrigger: {
        trigger: gridWrapper,
        start: "top 50%",
        toggleActions: "restart none none none"
      }
    }
  );
}
